module.exports = __webpack_public_path__ + "static/96-96-faab1832cbadbb53abcb3b1a3677bd11.svg";